var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "956.298 87.95 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7938"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M956.298 98.9a11 11 0 1 1 0 .1z",
    fill: "#533ffb",
    fillRule: "evenodd",
    "data-name": "Ellipse 91"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7908"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.715 99.951H968.3v3.414h-2.275V99.95h-3.414v-2.275h3.414v-3.414h2.275v3.414h3.414v2.275Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "icons8-add_file"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInCircle);
export default __webpack_public_path__ + "static/media/plus-in-circle.1518baddd83d5b9437869ad997c86c83.svg";
export { ForwardRef as ReactComponent };